import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AcceptOrgInvitationPage } from '@/features/invitations/org-accept-page';

const searchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

/** Public: company invitation links arrive by email/SMS/WhatsApp before the person is signed in. */
export const Route = createFileRoute('/organizations/invitations/accept')({
  validateSearch: searchSchema,
  component: AcceptRoute,
});

function AcceptRoute() {
  const { token } = Route.useSearch();
  return <AcceptOrgInvitationPage token={token} />;
}
